import StandardGateway from './lib/standard_gateway';

export default class GuidePerformanceGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/guide-performance');
  }

  fetchAll(params) {
    const dateRangeQuery = params?.dateRange ? { 'f.t': params.dateRange } : {};
    const guideCollectionIdQuery = params?.guideCollectionId ? { 'f.gid': params.guideCollectionId } : {};
    const interactionTypeQuery = params?.interactionType ? { 'f.it': params.interactionType } : {};
    return super.fetchAll(params, { ...dateRangeQuery, ...guideCollectionIdQuery, ...interactionTypeQuery });
  }
}
